import { WEBSITE_DETAILS } from "@/config";
import Whatsapp from "@/assets/whatsapp.webp";

const WhatsAppFloatButton = () => {
    return (
        <div className="fixed bottom-4 right-4 z-10 w-10 h-10 sm:hidden">
            <a href={WEBSITE_DETAILS.socialMedia.whatsapp} target="_blank">
                <img src={Whatsapp} alt="whatsapp" />
            </a>
        </div>
    );
};

export default WhatsAppFloatButton;